import {
  createDraftItem as publicCreateDraftItem,
  getDraftItem as publicGetDraftItem,
  updateDraftItem as publicUpdateDraftItem,
  deleteDraftItem as publicDeleteDraftItem,
  queryDraftItems as publicQueryDraftItems,
  typedQueryDraftItems as publicTypedQueryDraftItems,
  updateExtendedFields as publicUpdateExtendedFields,
  bulkCreateDraftItems as publicBulkCreateDraftItems,
  bulkUpdateDraftItems as publicBulkUpdateDraftItems,
  bulkDeleteDraftItems as publicBulkDeleteDraftItems,
  removeDraftItemFromTrashBin as publicRemoveDraftItemFromTrashBin,
  restoreDraftItemFromTrashBin as publicRestoreDraftItemFromTrashBin,
  getDeletedDraftItem as publicGetDeletedDraftItem,
  listDeletedDraftItems as publicListDeletedDraftItems,
  moveDraftItems as publicMoveDraftItems,
  sortDraftItemsBy as publicSortDraftItemsBy,
} from './fastgallery-draftitem-v1-draft-item-draft-items.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  DraftItemQuery,
  DraftItemsQueryBuilder,
  typedQueryDraftItems as universalTypedQueryDraftItems,
} from './fastgallery-draftitem-v1-draft-item-draft-items.universal.js';

function customQueryDraftItems(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryDraftItems(httpClient)(),
    typedQueryFunction: (query: DraftItemQuery) =>
      publicTypedQueryDraftItems(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): DraftItemsQueryBuilder;
  function overloadedQuery(
    query: DraftItemQuery
  ): ReturnType<typeof universalTypedQueryDraftItems>;
  function overloadedQuery(query?: DraftItemQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createDraftItem: MaybeContext<
  BuildRESTFunction<typeof publicCreateDraftItem> & typeof publicCreateDraftItem
> = /*#__PURE__*/ createRESTModule(publicCreateDraftItem);
export const getDraftItem: MaybeContext<
  BuildRESTFunction<typeof publicGetDraftItem> & typeof publicGetDraftItem
> = /*#__PURE__*/ createRESTModule(publicGetDraftItem);
export const updateDraftItem: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDraftItem> & typeof publicUpdateDraftItem
> = /*#__PURE__*/ createRESTModule(publicUpdateDraftItem);
export const deleteDraftItem: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDraftItem> & typeof publicDeleteDraftItem
> = /*#__PURE__*/ createRESTModule(publicDeleteDraftItem);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const bulkCreateDraftItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateDraftItems> &
    typeof publicBulkCreateDraftItems
> = /*#__PURE__*/ createRESTModule(publicBulkCreateDraftItems);
export const bulkUpdateDraftItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateDraftItems> &
    typeof publicBulkUpdateDraftItems
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateDraftItems);
export const bulkDeleteDraftItems: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteDraftItems> &
    typeof publicBulkDeleteDraftItems
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteDraftItems);
export const removeDraftItemFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDraftItemFromTrashBin> &
    typeof publicRemoveDraftItemFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRemoveDraftItemFromTrashBin);
export const restoreDraftItemFromTrashBin: MaybeContext<
  BuildRESTFunction<typeof publicRestoreDraftItemFromTrashBin> &
    typeof publicRestoreDraftItemFromTrashBin
> = /*#__PURE__*/ createRESTModule(publicRestoreDraftItemFromTrashBin);
export const getDeletedDraftItem: MaybeContext<
  BuildRESTFunction<typeof publicGetDeletedDraftItem> &
    typeof publicGetDeletedDraftItem
> = /*#__PURE__*/ createRESTModule(publicGetDeletedDraftItem);
export const listDeletedDraftItems: MaybeContext<
  BuildRESTFunction<typeof publicListDeletedDraftItems> &
    typeof publicListDeletedDraftItems
> = /*#__PURE__*/ createRESTModule(publicListDeletedDraftItems);
export const moveDraftItems: MaybeContext<
  BuildRESTFunction<typeof publicMoveDraftItems> & typeof publicMoveDraftItems
> = /*#__PURE__*/ createRESTModule(publicMoveDraftItems);
export const sortDraftItemsBy: MaybeContext<
  BuildRESTFunction<typeof publicSortDraftItemsBy> &
    typeof publicSortDraftItemsBy
> = /*#__PURE__*/ createRESTModule(publicSortDraftItemsBy);
export const queryDraftItems: MaybeContext<
  BuildRESTFunction<typeof customQueryDraftItems> & typeof customQueryDraftItems
> = /*#__PURE__*/ createRESTModule(customQueryDraftItems);

export {
  LinkType,
  LinkRel,
  Type,
  SortOrder,
  SortableFieldNames,
  WebhookIdentityType,
} from './fastgallery-draftitem-v1-draft-item-draft-items.universal.js';
export {
  DraftItem,
  Link,
  WixLink,
  WixLinkLinkOneOf,
  ExternalLink,
  PageLink,
  AnchorLink,
  DynamicPageLink,
  DocumentLink,
  EmailLink,
  PhoneLink,
  AddressLink,
  WhatsAppLink,
  TpaPageLink,
  MediaItem,
  MediaItemMediaOneOf,
  Image,
  FocalPoint,
  Point,
  UnsharpMasking,
  ExtendedFields,
  ReorderedDraftItem,
  CreateDraftItemRequest,
  CreateDraftItemResponse,
  GetDraftItemRequest,
  GetDraftItemResponse,
  UpdateDraftItemRequest,
  UpdateDraftItemResponse,
  DeleteDraftItemRequest,
  DeleteDraftItemResponse,
  QueryDraftItemsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryDraftItemsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  BulkCreateDraftItemsRequest,
  BulkCreateDraftItemsResponse,
  ItemMetadata,
  ApplicationError,
  BulkDraftItemResult,
  BulkActionMetadata,
  BulkUpdateDraftItemsRequest,
  MaskedDraftItem,
  BulkUpdateDraftItemsResponse,
  BulkUpdateDraftItemsResponseBulkDraftItemResult,
  BulkDeleteDraftItemsRequest,
  BulkDeleteDraftItemsResponse,
  BulkDeleteDraftItemsResponseBulkDraftItemResult,
  RemoveDraftItemFromTrashBinRequest,
  RemoveDraftItemFromTrashBinResponse,
  RestoreDraftItemFromTrashBinRequest,
  RestoreDraftItemFromTrashBinResponse,
  GetDeletedDraftItemRequest,
  GetDeletedDraftItemResponse,
  ListDeletedDraftItemsRequest,
  ListDeletedDraftItemsResponse,
  MoveDraftItemsRequest,
  MoveDraftItemsResponse,
  DraftItemNotFoundError,
  DraftItemNotInGalleryError,
  SortDraftItemsByRequest,
  SortByFieldSorting,
  SortDraftItemsByResponse,
  DraftItemSortUnsupportedError,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateDraftItemOptions,
  UpdateDraftItem,
  DraftItemsQueryResult,
  DraftItemsQueryBuilder,
  DraftItemQuerySpec,
  UpdateExtendedFieldsOptions,
  BulkCreateDraftItemsOptions,
  BulkUpdateDraftItemsOptions,
  ListDeletedDraftItemsOptions,
  MoveDraftItemsOptions,
  SortDraftItemsByOptions,
} from './fastgallery-draftitem-v1-draft-item-draft-items.universal.js';
export { utils } from './fastgallery-draftitem-v1-draft-item-draft-items.universal.js';
export {
  LinkTypeWithLiterals,
  LinkRelWithLiterals,
  TypeWithLiterals,
  SortOrderWithLiterals,
  SortableFieldNamesWithLiterals,
  WebhookIdentityTypeWithLiterals,
  MoveDraftItemsApplicationErrors,
  SortDraftItemsByApplicationErrors,
  CommonQueryWithEntityContext,
  DraftItemQuery,
} from './fastgallery-draftitem-v1-draft-item-draft-items.universal.js';
